/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import LocationDetails from '../pages/locationDetails';
import ResultsLocations from '../pages/ResultsLocations';
import ApplicationForm from '../pages/ApplicationForm';
import ApplicationFormEdit from '../pages/ApplicationFormEdit';
import PreviewPage from '../pages/PreviewPage';
import PreviewContext from '../components/context/PreviewContext';
import Register from '../pages/Register';
import ViewApplication from '../pages/ViewApplication';
import MyApplications from '../pages/MyApplications';
import Login from '../pages/Login';
import AuthKeycloakLandPage from '../pages/AuthKeycloakLandPage';
import UserFavorites from '../pages/UserFavorites';
import Foreas from '../pages/ΟΑ/Foreas';
import Ergo from '../pages/ΟΑ/Ergo';
import SmartTekmirio from '../pages/ΟΑ/Tekmirio/SmartTekmirio';
import SmartDetailsForeas from '../pages/ΟΑ/Foreas/SmartDetailsForeas';
import SullogesAll from '../pages/ΟΑ/Sulloges/SullogesAll';
import SmartDetailsSulloges from '../pages/ΟΑ/Sulloges/SmartDetailsSulloges';
import SmartDetailsErgo from '../pages/ΟΑ/Ergo/SmartDetailsErgo';
import SmartDetailsTekmirio from '../pages/ΟΑ/Tekmirio/SmartDetailsTekmirio';
import { routes_to_hide_navbar } from '../lib/static_values';
import LocationFormRequest from '../pages/LocationFormRequest';
import Calculator from '../pages/EmptyPages/Calculator';
import IntershipRequest from '../pages/EmptyPages/IntershipRequest';
import PreviewIntership from '../pages/EmptyPages/PreviewIntership';
import UserRegistrations from '../pages/UserRegistrations';
import EditProfessional from '../pages/professionals/EditProfessional';
import VisitorDetails from '../pages/VisitorDetails';
import EditVisitor from '../pages/EditVisitor';
import ProfDetails from '../pages/professionals/ProfDetails';
import CreateProfessional from '../pages/professionals/CreateProfessional';
import Professionals from '../pages/professionals/Professionals';
import ViewProfApplication from '../pages/professionals/ViewProfApplication';
import i18n from '../i18n';
import SmartAllAvailableApplications from '../pages/Visitor/applications/_smart/SmartAllAvailableApplications';
import SmartSpecificFromScratchApplication from '../pages/Visitor/applications/_smart/SmartSpecificFromScratchApplication';
import SmartSpecificFormDetails from '../pages/Visitor/applications/_smart/SmartSpecificFormDetails';
import UserProfile from '../pages/Admin/UserProfile';
import UserService from '../services/UserService';
import { IntExt, Permissions } from '../lib/permissions';
import MyInternalRequests from '../pages/Admin/MyInternalRequests';
import NavBar from '../components/NavBar/NavBar';
import { UnauthorizedRedirect } from '../components/UnauthorizedRedirect';
import { useTranslation } from 'react-i18next';
import ViewLocationForm from '../pages/ViewLocationForm';
import EmptyPage from '../components/EmptyPage/EmptyPage';
import EmailRegister from '../pages/EmailRegister';
import HttpService from '../services/HttpService';
import { CookiesValues } from '../lib/generalTypes';
import Cookies from 'js-cookie';

function millisToMinutesAndSeconds(millis: number) {
  const minutes = Math.floor(millis / 60000);
  const seconds = Number(((millis % 60000) / 1000).toFixed(0));
  return minutes + ':' + (seconds < 10
    ? '0'
    : '') + seconds;
}

const setLanguage = (lang: string) => {

  i18n.changeLanguage(lang === 'en-US'
    ? 'en'
    : 'el');
};
millisToMinutesAndSeconds(298999);

function WordPressApp() {
  const { pathname } = useLocation();
  const is_external = UserService.hasRole([IntExt.External]);
  const { t } = useTranslation();

  React.useEffect(() => {
    if (pathname !== '/preview' && pathname !== '/location/new') {
      sessionStorage.removeItem('id');
    }
    if (pathname !== '/professionals/new') {
      localStorage.removeItem('professionalId');
    }
  }, [pathname]);


  // React.useEffect(() => {
  //   (UserService.isAuthenticated() && UserService.hasRole([IntExt.Internal])) &&
  //     UserService.doLogout();
  // }, []);


  useEffect(() => {
    // Get the initial language and set it
    const initialLang = document?.getElementsByTagName('html')?.[0]?.getAttribute('lang');
    if (initialLang) {
      setLanguage(initialLang);
    }

    // Create a new MutationObserver instance
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const observer = new MutationObserver((mutationsList, observer) => {
      // Iterate through each mutation in the list
      for (const mutation of mutationsList) {
        // Check if the mutation is a change to the lang attribute on the html element
        if (mutation.type === 'attributes' && mutation.attributeName === 'lang') {
          // Get the new value of the lang attribute
          const mutationTarget = mutation.target as HTMLElement;
          const newLang = mutationTarget.getAttribute('lang') || '';
          setLanguage(newLang);
        }
      }
    });

    // Observe changes to the html element's attributes
    observer.observe(document.getElementsByTagName('html')[0], { attributes: true });

    // Cleanup function to disconnect the observer when the component unmounts
    return () => observer.disconnect();
  }, []);

  useEffect(() => {

    if (Cookies.get(CookiesValues.RLogCountry) !== 'true' || Cookies.get(CookiesValues.RLogLoginLogout) !== 'true') {
      return;
    }

    if (is_external) {

      const intervalId = setInterval(async () => {
        await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/crm/duration`);
      }, 60 * 1000); // send a request every 1 minute = 60 * 1000

      return () => clearInterval(intervalId);

    }

  }, []);
  return (
    <>
      {!routes_to_hide_navbar.includes(pathname.split('/').filter(Boolean)[0])
        ? <>
          <NavBar />
          <Routes>
            <Route
              path='/'
              element={<Login />}
            />
            <Route
              path='/email-register'
              element={<EmailRegister />}
            />
            <Route
              path='/signin'
              element={<Login />}

            />

            <Route
              path='/location/details/:id'
              element={<LocationDetails />}
            />
            <Route
              path='/location'
              element={<ResultsLocations />}
            />
            <Route
              path='/location/new'
              element={
                UserService.hasRole([Permissions.PermissionExternalLocationApplicationCreateMy])
                  ? <PreviewContext.PreviewProvider>
                    <ApplicationForm />
                  </PreviewContext.PreviewProvider>
                  : <UnauthorizedRedirect to='/' snackMessage={t('Επιλέξτε Είσοδο στο Σύστημα μέσω πιστοποίησης από την ΑΑΔΕ για να μπορέσετε να καταχωρίσετε μια τοποθεσία') as string} />
              }
            />
            <Route
              path='/preview'
              element={
                !UserService.isAuthenticated()
                  ? <UnauthorizedRedirect to='/' snackMessage={t('Απαιτείται σύνδεση για να δείτε το υλικό') as string} /> :
                  UserService.hasRole([Permissions.PermissionExternalLocationApplicationCreateMy])
                    ? <PreviewContext.PreviewProvider>
                      <PreviewPage />
                    </PreviewContext.PreviewProvider>
                    : <Navigate to='/' replace />
              }
            />
            <Route
              path='/location/edit/:id'
              element={
                UserService.hasRole([
                  Permissions.PermissionExternalLocationApplicationModificationCreateMy])
                  ? <PreviewContext.PreviewProvider>
                    <ApplicationFormEdit />
                  </PreviewContext.PreviewProvider>
                  : <UnauthorizedRedirect to='/' />
              }
            />
            <Route
              path='view/:id'
              element={< ViewApplication />}
            />
            <Route
              path='/location/request-form/:id'
              element={
                !UserService.isAuthenticated()
                  ? <UnauthorizedRedirect to='/' snackMessage={t('Απαιτείται σύνδεση για να συνεχίσετε με αυτή την ενέργεια') as string} />
                  : <LocationFormRequest />}
            />
            <Route
              path='/register'
              element={<Register />}
            />
            <Route
              path='/applications'
              element={<SmartAllAvailableApplications redirectsOutsideShadow={false} />}
            />΄
            <Route
              path='/applications/:id'
              element={<SmartSpecificFromScratchApplication />}
            />
            <Route
              path='/view-interest/:id'
              element={<ViewLocationForm />}
            />
            <Route
              path='/applications/details/:id'
              element={<SmartSpecificFormDetails />}
            />
            <Route
              path='/my-applications'
              element={
                !UserService.isAuthenticated()
                  ? <UnauthorizedRedirect to='/' snackMessage={t('Απαιτείται σύνδεση για να δείτε το υλικό') as string} /> :
                  UserService.hasRole([IntExt.Internal])
                    ? < MyInternalRequests />
                    : < MyApplications />
              }
            />
            <Route
              path='/benefit-calculator'
              element={<Calculator />}
            />
            <Route
              path='/my-favorites'
              element={
                !UserService.isAuthenticated()
                  ? <UnauthorizedRedirect to='/' snackMessage={t('Απαιτείται σύνδεση για να δείτε το υλικό') as string} />
                  : UserService.hasRole([
                    Permissions.PermissionExternalLocationFavoritesReadMy,
                    Permissions.PermissionExternalProfessionalsFavoritesReadMy
                  ])
                    ? <UserFavorites />
                    : !is_external
                      ? <UnauthorizedRedirect to='/profile' replace
                        snackMessage='Συνεχίστε στο Διαχειριστικό για να δείτε τις καταχωρίσεις σας' />
                      : <UnauthorizedRedirect to='/location' replace
                        snackMessage={t('Δεν έχετε δικαίωμα να δείτε τα αγαπημένα!') as string} />
              }
            />
            <Route
              path='/my-registrations'
              element={
                !UserService.isAuthenticated()
                  ? <UnauthorizedRedirect to='/' snackMessage={t('Απαιτείται σύνδεση για να δείτε το υλικό') as string} /> :
                  UserService.hasRole([
                    Permissions.PermissionExternalLocationReadMy,
                    Permissions.PermissionExternalProfessionalReadMy])
                    ? < UserRegistrations />
                    : !is_external
                      ? <UnauthorizedRedirect to='/profile' replace
                        snackMessage='Συνεχίστε στο Διαχειριστικό για να δείτε τις καταχωρίσεις σας' />
                      : <UnauthorizedRedirect to='/profile' replace
                        snackMessage={t('Δεν έχετε δικαίωμα προβολής των καταχωρίσεών σας') as string} />

              }
            />
            <Route
              path='/auth/keycloak/landpage'
              element={< AuthKeycloakLandPage />}
            />
            <Route
              path='/professionals'
              element={
                <Professionals />
              }
            />
            <Route
              path='/professionals/details/:id'
              element={< ProfDetails />}
            />
            <Route
              path='/professionals/new'
              element={
                !UserService.isAuthenticated()
                  ? <UnauthorizedRedirect to='/' snackMessage={t('Απαιτείται σύνδεση για να δείτε το υλικό') as string} />
                  : UserService.hasRole([Permissions.PermissionExternalProfessionalApplicationCreateMy])
                    ? <CreateProfessional />
                    : <UnauthorizedRedirect to='/' />
              }
            />
            <Route
              path='/professionals/edit/:id'
              element={
                !UserService.isAuthenticated()
                  ? <UnauthorizedRedirect to='/' snackMessage={t('Απαιτείται σύνδεση για να δείτε το υλικό') as string} />
                  : !is_external
                    ? <UnauthorizedRedirect to='/' snackMessage='Συνεχίστε στο Διαχειριστικό για επεξεργασία του Επαγγελματία' />
                    : UserService.hasRole([
                      Permissions.PermissionExternalProfessionalApplicationModificationCreateMy,
                      Permissions.PermissionExternalProfessionalApplicationCreateMy
                    ])
                      ? <PreviewContext.PreviewProvider>
                        <EditProfessional />
                      </PreviewContext.PreviewProvider>
                      : <UnauthorizedRedirect to='/' />

              }
            />
            <Route
              path='/professionals/view/:id'
              element={
                <ViewProfApplication />
              }
            />
            <Route
              path='/visitor/details/:id'
              element={!UserService.isAuthenticated()
                ? <UnauthorizedRedirect to='/' snackMessage={t('Απαιτείται σύνδεση για να δείτε το υλικό') as string} /> :
                < VisitorDetails />}
            />
            <Route
              path='/visitor/edit/:id'
              element={!UserService.isAuthenticated()
                ? <UnauthorizedRedirect to='/' snackMessage={t('Απαιτείται σύνδεση για να δείτε το υλικό') as string} /> :
                < EditVisitor />}
            />
            <Route
              path='/search-projects'
              element={<Ergo />}
            />
            <Route
              path='/search-projects/details/:id'
              element={<SmartDetailsErgo />}
            />
            <Route
              path='/collections'
              element={<SullogesAll />}
            />
            <Route
              path='/collections/details/:id'
              element={<SmartDetailsSulloges />}
            />
            {/* <Route
              path='search-collections'
              element={<SmartSulloges />}
            /> */}
            <Route
              path='/search-documents'
              element={<SmartTekmirio />}
            />
            <Route
              path='/search-documents/details/:id'
              element={<SmartDetailsTekmirio />}
            />
            <Route
              path='/search-organisation'
              element={<Foreas />}
            />
            <Route
              path='/search-organisation/details/:id'
              element={<SmartDetailsForeas />}
            />
            <Route
              path='/profile'
              element={!UserService.isAuthenticated()
                ? <UnauthorizedRedirect to='/' snackMessage={t('Απαιτείται σύνδεση για να δείτε το υλικό') as string} /> :
                <UserProfile />}
            />
            <Route
              path='/profile/edit'
              element={!UserService.isAuthenticated()
                ? <UnauthorizedRedirect to='/' snackMessage={t('Απαιτείται σύνδεση για να δείτε το υλικό') as string} /> :
                <EditVisitor />}
            />
            {/* ------empty pages------ */}
            <Route
              path='/calculator'
              element={<Calculator />}
            />
            <Route
              path='/intership/request'
              element={<IntershipRequest />}
            />
            <Route
              path='/intership/request-preview'
              element={<PreviewIntership />}
            />
            <Route path='*'
              element={<EmptyPage errorMsg={t('Η σελίδα που ζητήσατε δεν βρέθηκε.')} />} />
          </Routes>
        </>
        : null}
    </>
  );
}

export default WordPressApp;
